import React, { Component, Fragment } from 'react'
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { PATHS } from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import { Link } from 'react-router-dom';
import BaggageList from './BaggageList';
import { Button, Icon } from 'antd';
import { omit } from 'lodash';

let permisionActions = [];

class Baggage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.baggageState.pageSize,
                pageIndex: this.props.baggageState.pageIndex,
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BAGGAGE);
        this.props.getListBaggages(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, baggages } = this.props.baggageState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};

        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'baggages'}
                        titleHeader={t('navigation.baggages')}
                        componentRight={
                            <Fragment>
                                
                                {
                                    permisionActions && permisionActions.allowCreate &&
                                    <Button className="btn btn-primary ml-3">
                                        <Link to={PATHS.BAGGAGE.CREATE.path} >+ Tạo mới</Link>
                                    </Button>
                                }
                            </Fragment>
                        }
                    />
                    <BaggageList loading={isFetching}
                                  permisions={permisionActions}
                                  baggages={baggages}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteBaggage}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListBaggages(newFilters);
    }

    onDeleteBaggage = (item) => {
        this.props.deleteBaggageDetail(item, {
            filters: {
                pageSize: this.props.baggageState.pageSize,
                pageIndex: this.props.baggageState.pageIndex
            }
        });
    }

}

export default Baggage
